<div class="auth-page auth-page--flow">
  <div class="auth-page__grid">
    <app-auth-showcase-aside />

<main class="auth-main auth-main--flow auth-main--dense">
      <div class="auth-main__content">
        <nav class="auth-mobile-nav" [attr.aria-label]="'auth.login.back' | translate">
          <a
            class="auth-back auth-back--icon"
            routerLink="/authentication"
            [attr.aria-label]="'auth.login.back' | translate"
          >
            <i-tabler name="chevron-left" class="auth-back__icon flex"></i-tabler>
          </a>
        </nav>

        <a class="auth-brand" [routerLink]="['/authentication']">
          <img
            src="/assets/images/logos/logo.svg"
            class="auth-brand__logo"
            [attr.alt]="'auth.register.logoAlt' | translate"
          />
        </a>

        <div class="auth-panel">
          <h1 class="auth-panel__title">{{ 'auth.register.title' | translate }}</h1>
          <p class="auth-panel__subtitle">
            {{
              (claimBusinessName ? 'auth.register.claimSubtitle' : 'auth.register.subtitle')
                | translate
            }}
          </p>

          <app-auth-google-signin-button
            class="auth-google-btn--hub"
            text="signup_with"
            [label]="'auth.register.googleCta' | translate"
            [loadingLabel]="
              isSubmitting
                ? ('auth.register.googleSubmitting' | translate)
                : ('auth.register.googleLoading' | translate)
            "
            [visible]="showGoogleSignIn"
            [loading]="googleAuthInitializing || isSubmitting"
          />

          <div class="auth-divider">{{ 'auth.register.divider' | translate }}</div>

          <form class="auth-form" [formGroup]="form" (ngSubmit)="submit()" authScrollOnFocus>
            <div class="auth-form__row">
              <mat-form-field appearance="outline" color="primary" subscriptSizing="dynamic">
                <mat-label>{{ 'auth.register.firstName' | translate }}</mat-label>
                <input matInput formControlName="uname" autocomplete="given-name" />
                <mat-error>
                  @if (f['uname'].hasError('required')) {
                    {{ 'auth.register.firstNameRequired' | translate }}
                  } @else if (f['uname'].hasError('minlength')) {
                    {{ 'auth.register.firstNameMinLength' | translate }}
                  }
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" color="primary" subscriptSizing="dynamic">
                <mat-label>{{ 'auth.register.lastName' | translate }}</mat-label>
                <input matInput formControlName="lname" autocomplete="family-name" />
                <mat-error>
                  @if (f['lname'].hasError('required')) {
                    {{ 'auth.register.lastNameRequired' | translate }}
                  } @else if (f['lname'].hasError('minlength')) {
                    {{ 'auth.register.lastNameMinLength' | translate }}
                  }
                </mat-error>
              </mat-form-field>
            </div>

            <mat-form-field appearance="outline" color="primary" subscriptSizing="dynamic">
              <mat-label>{{ 'auth.register.businessName' | translate }}</mat-label>
              <input matInput formControlName="businessName" autocomplete="organization" />
              <mat-error>
                @if (f['businessName'].hasError('minlength')) {
                  {{ 'auth.register.businessNameMinLength' | translate }}
                }
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" color="primary" subscriptSizing="dynamic">
              <mat-label>{{ 'auth.register.email' | translate }}</mat-label>
              <input matInput type="email" inputmode="email" autocomplete="email" formControlName="email" />
              <mat-error>
                @if (f['email'].hasError('required')) {
                  {{ 'auth.register.emailRequired' | translate }}
                } @else if (f['email'].hasError('pattern')) {
                  {{ 'auth.register.emailInvalid' | translate }}
                }
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" color="primary" subscriptSizing="dynamic">
              <mat-label>{{ 'auth.register.password' | translate }}</mat-label>
              <input
                matInput
                [type]="hidePassword ? 'password' : 'text'"
                autocomplete="new-password"
                formControlName="password"
              />
              @if (passwordIsValid()) {
                <mat-icon matSuffix class="auth-password-ok" aria-hidden="true">check_circle</mat-icon>
              }
              <button
                mat-icon-button
                matSuffix
                type="button"
                [attr.aria-label]="hidePassword ? 'Mostrar contraseña' : 'Ocultar contraseña'"
                (click)="hidePassword = !hidePassword"
              >
                <mat-icon>{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
              </button>
              <mat-error>
                @if (f['password'].hasError('required')) {
                  {{ 'auth.register.passwordRequired' | translate }}
                }
              </mat-error>
            </mat-form-field>

            @if (showPasswordRules()) {
              <div class="auth-password-rules" aria-live="polite">
                @for (rule of passwordRules; track rule) {
                  <div class="auth-password-rule" [class.auth-password-rule--valid]="passwordMeets(rule)">
                    <mat-icon aria-hidden="true">{{ passwordMeets(rule) ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                    <span>{{ ('auth.register.passwordRule' + rule) | translate }}</span>
                  </div>
                }
              </div>
            }

            <mat-checkbox color="primary" formControlName="legalAccepted">
              {{ 'auth.register.legalLead' | translate }}
              <a routerLink="/legal/terminos" target="_blank" rel="noopener">{{
                'auth.register.legalTerms' | translate
              }}</a>
              {{ 'auth.register.legalAnd' | translate }}
              <a routerLink="/legal/privacidad" target="_blank" rel="noopener">{{
                'auth.register.legalPrivacy' | translate
              }}</a>
            </mat-checkbox>
            @if (showFieldError(f['legalAccepted']) && f['legalAccepted'].errors?.['required']) {
              <mat-error class="auth-legal-error">{{
                'auth.register.legalRequired' | translate
              }}</mat-error>
            }

            @if (errorMessage) {
              <div class="auth-form-error" role="alert">
                <p>{{ errorMessage }}</p>
                @if (emailAlreadyRegistered) {
                  <a
                    class="auth-form-error__cta"
                    [routerLink]="['/authentication/login']"
                    [queryParams]="loginWithCreateBusinessQuery"
                  >
                    {{ 'auth.register.goToLoginCreateBusiness' | translate }}
                  </a>
                }
              </div>
            }

            <button mat-flat-button color="primary" class="auth-btn-primary" type="submit" [disabled]="isSubmitting">
              @if (isSubmitting) {
                <mat-spinner diameter="20" aria-hidden="true"></mat-spinner>
                {{ 'auth.register.submitting' | translate }}
              } @else {
                {{ 'auth.register.submit' | translate }}
              }
            </button>
          </form>
        </div>

        <p class="auth-footer">
          {{ 'auth.register.loginPrompt' | translate }}
          <a [routerLink]="['/authentication/login']">{{ 'auth.register.loginLink' | translate }}</a>
        </p>
      </div>
    </main>
  </div>
</div>
